import React from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, CircleMarker, Popup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";

export const ResultsMap = ({ place, items }) => {
  const pts = items.filter((x) => x.lat !== null && x.lat !== undefined);
  return (
    <div className="card-premium overflow-hidden mb-8 relative z-0" data-testid="results-map">
      <MapContainer key={`${place.lat},${place.lng}`} center={[place.lat, place.lng]} zoom={8} scrollWheelZoom={false} style={{ height: 380, width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
        <CircleMarker center={[place.lat, place.lng]} radius={11} pathOptions={{ color: "#0D2B5A", fillColor: "#0D2B5A", fillOpacity: 0.9 }}>
          <Tooltip permanent direction="top" offset={[0, -10]}>{place.name}</Tooltip>
        </CircleMarker>
        {pts.map((x) => (
          <CircleMarker key={x.id} center={[x.lat, x.lng]} radius={8} pathOptions={{ color: "#C98A3C", fillColor: "#E2A453", fillOpacity: 0.85 }}>
            <Popup><Link to={`/artista/${x.id}`} className="font-semibold">{x.companyName}</Link><br/>{x.baseLocation}{x.distanceKm !== null && x.distanceKm !== undefined ? ` · ${x.distanceKm} km` : ""}</Popup>
          </CircleMarker>
        ))}
      </MapContainer>
      <div className="px-4 py-2 text-xs text-slate-500 flex gap-4"><span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-navy inline-block"/>Comune dell'evento</span><span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-gold inline-block"/>Sede artista / fornitore</span></div>
    </div>
  );
};
